module.exports = __webpack_public_path__ + "static/media/startExtraChallenge.31f0be42.svg";